import * as x from '../helpers/xmlHelpers';
import { Image } from './image';

export class InspectionDetail {
    constructor(doc)
    {
		this.label = null
		this.inspectionDate = null
		this.propertyExteriorInspectionMethodType = null
		this.propertyInteriorInspectionMethodType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.inspectionDate = x.getMISMODateElement(doc, "./ns:InspectionDate");
		this.propertyExteriorInspectionMethodType = x.getStringElement(doc, "./ns:PropertyExteriorInspectionMethodType");
		this.propertyInteriorInspectionMethodType = x.getStringElement(doc, "./ns:PropertyInteriorInspectionMethodType");
   }
}

export class Inspection {
    constructor(doc) {
		this.label = null
		this.images = []
		this.inspectionDetail = null
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:IMAGES/ns:IMAGE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.images.push(new Image(xn));
			});
		}

		node = x.selectSingleNode(doc, "./ns:INSPECTION_DETAIL");
		if (node !== null)
				this.inspectionDetail = new InspectionDetail(node);
    }
}

